export default __webpack_public_path__ + "static/media/CMS_EV Drivers.54fc93d6.svg";